import React from 'react';
import { Spinner, Text } from '@carnica/ui-kit';
import { IconFileFillFilled, IconImportFilled } from '@carnica/graphics';
import { cnBem } from "../../../../shared/lib";
import { withMessageWrapper } from "../../lib";
import { useFileDoc } from "../../lib/hooks/useFileDoc";
import styles from "./styles.pcss";
var cnFileView = cnBem('file', styles);
var renderIcon = function renderIcon(isLoading, isDownloadStep) {
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Spinner, {
      view: "dark-white",
      "data-t-id": "ui-FileView"
    });
  }
  if (isDownloadStep) {
    return /*#__PURE__*/React.createElement(IconImportFilled, null);
  }
  return /*#__PURE__*/React.createElement(IconFileFillFilled, null);
};
var FileViewRender = function FileViewRender(_ref) {
  var message = _ref.message,
    side = _ref.side;
  var _useFileDoc = useFileDoc(message),
    name = _useFileDoc.name,
    size = _useFileDoc.size,
    type = _useFileDoc.type,
    isLoading = _useFileDoc.isLoading,
    isDownloadStep = _useFileDoc.isDownloadStep,
    handleCLick = _useFileDoc.handleCLick;
  return /*#__PURE__*/React.createElement("div", {
    className: cnFileView('wrapper'),
    onClick: handleCLick
  }, /*#__PURE__*/React.createElement("div", {
    className: cnFileView('icon', {
      loading: isLoading
    })
  }, renderIcon(isLoading, isDownloadStep)), /*#__PURE__*/React.createElement("div", {
    className: cnFileView('info')
  }, /*#__PURE__*/React.createElement("div", {
    className: cnFileView('text')
  }, /*#__PURE__*/React.createElement(Text, {
    className: cnFileView('name'),
    color: side === 'main' ? 'primary' : 'primary-invert',
    variant: "body-small"
  }, name), /*#__PURE__*/React.createElement(Text, {
    color: side === 'main' ? 'primary' : 'primary-invert',
    variant: "body-small"
  }, ".", type)), /*#__PURE__*/React.createElement(Text, {
    className: cnFileView('size'),
    tagName: "span",
    variant: "body-small"
  }, size)));
};
export var FileView = withMessageWrapper({
  bordered: true,
  offset: 'none',
  wrapperClassName: cnFileView()
})(FileViewRender);